import { styled } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

const GradientRobotIcon = styled(Box)`
  background: ${({ theme }) =>
    `linear-gradient(135deg, ${theme.colors.primary} 0%, #8b5cf6 100%)`};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  /* Multi-layered shadow for visibility */
  box-shadow:
    0 4px 12px rgba(0, 0, 0, 0.1),
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 0 15px rgba(59, 130, 246, 0.15),
    0 0 30px rgba(139, 92, 246, 0.1);

  /* Gradient border effect */
  border: 2px solid transparent;
  background-clip: padding-box;
`;

export const AITitle = () => (
  <Box display="flex" alignItems="center" gridColumnGap={2} font="h2-semibold">
    <GradientRobotIcon fontSize="20px" lineHeight={1}>
      🤖
    </GradientRobotIcon>
    <span>{s__('AIForm|AI Assistant')}</span>
  </Box>
);
